import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Topic } from '@shapeable/gesda-types';
import { SliceLayoutBoundary, SiteHeaderLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutProps, ExplorerTabs, } from '@shapeable/ui';
import { ExplorerProvider } from '../providers/explorer-provider';
import { TopicTabsLayout } from './topic-tabs-layout';
import { TopicViewLayout } from './topic-view-layout';
import { useRadarMap } from '../../hooks/use-radar-map';
import { useContentView } from '../../hooks/use-content-view';
import { TOPIC_CONTENT_TAB_VIEWS } from '../../types';
import { RadarChartMain } from '../elements/radar-chart-main';
import { RadarChart } from '../elements/radar-chart';
const cls = classNames('topic-banner-layout');

// -------- Types -------->

// -------- Props -------->

export type TopicExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity?: Topic;
};

export const TopicExplorerLayoutDefaultProps: Omit<TopicExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});

const RadarChartStyles = breakpoints({
  base: css`
  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
      RadarChart: styled(RadarChart)`${RadarChartStyles}`,

};

export const TopicExplorerLayout: Shapeable.FC<TopicExplorerLayoutProps> = (props) => {
  const { className, children, entity } = props;
  const { isShown } = useRadarMap();
  const { activeView, setActiveView, showView } = useContentView('overview', TOPIC_CONTENT_TAB_VIEWS);

  return (
    <ExplorerProvider>
    {/* <BackButtonEntityProvider value={entity.trend}> */}
    <My.Container>
      <My.Header />
      <SliceLayoutBoundary boundary='none' >
      <My.Layout 
        asideMaxWidth={800}
        entity={entity}
        className={cls.name(className)}
        asideIsRevealed={isShown}
        stickyTopOffset={90}
        showAsideHeader={false}
        
        tabs={
          <TopicTabsLayout entity={entity} activeView={activeView} setActiveView={setActiveView} />
        }
        content={
          <TopicViewLayout entity={entity} showView={showView} />
        }
        dataVizMain={
          <RadarChartMain />
        }

        dataViz={
          <My.RadarChart initialY={10} />
        }
        />
        </SliceLayoutBoundary>
    </My.Container>
    {/* </BackButtonEntityProvider> */}
    </ExplorerProvider>
  )
};

TopicExplorerLayout.defaultProps = TopicExplorerLayoutDefaultProps;
TopicExplorerLayout.cls = cls;